import { AdultAgeDropdown } from "@/components/Inputs/AdultAgeSelect/AdultAgeDropdown.tsx";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { RootAttribute } from "@/stores/EngineStore/enums/RootAttribute.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { memo } from "react";
import { useTranslation } from "react-i18next";

export const AdultAgeSelect = memo((props: { cartItem: CartAccommodationItem; compact?: boolean }) => {
  const { t } = useTranslation();
  const rootAttributes = useEngineStore((state) => state.rootAttributes);

  if (!props.cartItem.adults?.length || !rootAttributes?.[RootAttribute.ShowAdultAgePicker]) return null;

  return (
    <div className={`c-age-select${props.compact ? " c-age-select--compact" : ""}`}>
      {props.cartItem.adults.map((adult, index) => (
        <AdultAgeDropdown
          key={adult.id}
          adult={adult}
          cartItemId={props.cartItem.id}
          compact={props.compact}
          label={props.compact ? `${t("adultAge")} ${index + 1}` : t("adultAge")}
        />
      ))}
    </div>
  );
});

AdultAgeSelect.displayName = "AdultAgeSelect";
